import React from 'react';

import useClubOwnerTypeDropdown from './UseClubOwnerTypeDropdown';

import Dropdown from '@usas/ui-web/components/dropdowns/Dropdown';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const ClubOwnerTypeDropdown = ({ label, name, value, error, message, onChange }) => {
  const { clubOwnerTypeState } = useClubOwnerTypeDropdown();

  return clubOwnerTypeState.message
    ? <span className={global.LoadingMsg}>{clubOwnerTypeState.message}</span>
    : (
      <Dropdown
        error={error}
        label={label}
        message={message}
        options={clubOwnerTypeState.dataAsOptionsWithNames}
        name={name}
        value={value}
        onChange={onChange}
        isLoading={clubOwnerTypeState.isLoading}
      />
    );
};

export default ClubOwnerTypeDropdown;